<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <OrderManager />
    </AccountViewBase>
</template>

<script>
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import { useOrderStore } from '@/stores/order';
    import { useProductsStore } from '@/stores/products';
    import OrderManager from '@/components/subscriptions/order/OrderManager';

    export default {
        name: 'SubscriptionsView',
        components: {
            AccountViewBase,
            OrderManager
        },
        mixins: [i18nViewMixin, accountMixin],
        data() {
            return {
                seo_title: 'views.account_order.seo_title',
                viewLoading: false,
            };
        },
        computed: {
            orderStore() {
                return useOrderStore();
            },
            loading() {
                return this.accountLoading || this.viewLoading;
            },
        },
        async mounted() {
            this.orderStore.resetOrder();

            this.viewLoading = true;
            await useProductsStore().getProducts();
            this.viewLoading = false;
        },
        unmounted() {
            this.orderStore.resetOrder();
        },
    }
</script>
